<template>
  <div class="season">
    <span>Saison</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.name+' ['+item.id+']'">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersCompetitionSeason',
  computed: {
    items () { return this.$store.getters['Sport/Season/list'] }
  }
}
</script>

<style scoped>
  .season{
    display:flex;
    height:20px;
    align-items:center;
    margin-bottom:10px
  }
  .season > span{
    font-size:14px
  }
  .season > select{
    height:18px;
    margin-left:5px
  }
</style>
